export { Icon } from './icon';

export function gridCol(props) {
  const {
    xs, sm, md, lg, xl, offset, className,
  } = props;
  const cl = {
    ['col-' + xs]: xs,
    ['col-sm-' + sm]: sm,
    ['col-md-' + md]: md,
    ['col-lg-' + lg]: lg,
    ['col-xl-' + xl]: xl,
    ['offset-md-' + offset]: offset,
    [className]: className,
  };
  return cl;
}

export function gridFormGroup(props) {
  const { size, required, disabled, nostyle, isWide, error, type, withTime, lookupName, multiple } = props;

  const cl = {
    'form-group': true,
    'form-group_date': type === 'date',
    'form-group_datetime': type === 'date' && withTime,
    'form-group_number': type === 'number',
    'form-group_disabled': disabled,
    // 'form-row': inline || labelwidth,
    ['form-group-' + size]: size,
    'form-required': required,
    ...gridCol(props),
    'no-style': nostyle,
    'msfield-wide': isWide,
    'form-group_has-error': error,
    'form-group_ac-multi': lookupName && multiple,
  };
  return cl;
}

export function classFormControl(props) {
  const { size, className, skipDefaultClass, lookupFreeAdd, nostyle } = props;

  const cl = nostyle ? {
    [className]: className,
  } : {
    'form-control': true,
    'field-lookup-free-add': lookupFreeAdd,
    'form-control-invalid': props.error,
    ['form-control' + (size ? '-' + size : '')]: true,
    // 'msfield-input': !skipDefaultClass,
    'is-invalid': props.error,
    [className]: className,
  };
  return cl;
}
